import { TypedAttributes, TypedElement } from '../htmlElementTyped';
import { getPostThread, postToPlainText } from '../lib/bsky';
import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { randomFlag } from '../lib/randomFlag';

export interface BskyAttributes extends TypedAttributes {
  uri: string;
}

export class BskyEmbed extends TypedElement<BskyAttributes> {
  likeLimit = 100;

  constructor() {
    super();
  }

  async render() {
    const { uri } = this.typedAttributes;
    const result = await getPostThread(uri, this.likeLimit);

    if (result.isErr()) {
      console.error(result.error);
      return [];
    }

    const { post, author, likes, replies } = result.value;
    let postText = postToPlainText(post);

    const postId = post.uri.split('/').pop();
    const postLink = postId
      ? `https://bsky.app/profile/${author.handle}/post/${postId}`
      : `https://bsky.app/profile/${author.handle}/`;

    this.innerHTML = '';
    this.append(
      <div className="thread" style="margin-bottom: 12px">
        <div className="comment">
          <div className="content">
            <p className="commentHeader">
              💬
              <div className="avatar">
                <img
                  src={author.avatar || randomFlag(author.handle)}
                  alt={author.handle}
                />
              </div>
              <a
                href={postLink}
                target="_blank"
                rel="noreferrer"
                className="author"
              >
                {author.displayName || author.handle}
              </a>
              <span className="date">
                {new Date(post.record.createdAt).toLocaleString()}
              </span>
            </p>
            <p className="commentBody">
              {...postText.split('\n').map((chunk) => <div>{chunk}</div>)}
            </p>
            {post.embed?.$type === 'app.bsky.embed.images#view' ? (
              <div className="comment-image">
                {...post.embed.images.map((img) => (
                  <img src={img.fullsize} alt={img.alt} />
                ))}
              </div>
            ) : (
              ''
            )}
            <p className="commentBody" style="opacity: 0.75; ">
              {likes.length >= this.likeLimit
                ? `${this.likeLimit}+`
                : likes.length}{' '}
              likes & {replies.length} replies on{' '}
              <a href={postLink} target="_blank" rel="noreferrer">
                Bluesky
              </a>
              &nbsp;/&nbsp;
              <a
                href={postLink.replace('bsky', 'witchsky')}
                target="_blank"
                rel="noreferrer"
              >
                Witchsky
              </a>
            </p>
          </div>
        </div>
      </div>,
    );
  }

  connectedCallback() {
    void this.render();
  }
}

/**
 * <blockquote
 *  class="bluesky-embed"
 *  data-bluesky-uri="at://did:plc:qvywnipfiyrd6v4qdf4x27wy/app.bsky.feed.post/3mwbpbvzf6k27"
 *  data-bluesky-cid="bafyreibsry3dfoyunxf2kywl3zdbqzgn4crdxrrya5p353oct6xthgtvmq"
 *  data-bluesky-embed-color-mode="system"
 * >
 *  <p lang="en">
 *    The ideal is an identity distinct from big tech/uncomplicated boosterism, one that heavily leverages tech for concrete daily gains and not just future-utopian goals, something that people can associate with their friend who has a really good plex server, not with big tech &quot;fix everything&quot; efforts
 *  </p>
 *  &mdash; hikikomorphism (<a href="https://witchsky.app/profile/did:plc:qvywnipfiyrd6v4qdf4x27wy?ref_src=embed">@hikikomorphism.bsky.social</a>) <a href="https://witchsky.app/profile/did:plc:qvywnipfiyrd6v4qdf4x27wy/post/3mwbpbvzf6k27?ref_src=embed">September 25, 2026 at 2:44 AM</a>
 * </blockquote>
 * <script async src="https://embed.bsky.app/static/embed.js" charset="utf-8"></script>
 * */
